// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"441":"0b487251","898":"88222a0c"}[chunkId] + ".chunk.css";
};